import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastrService:ToastrService) { }

  success(message) {
    this.toastrService.success(message, '', {
      timeOut: 5000,
      closeButton: true
    });
  }

  error(message, title?) {
    this.toastrService.error(message, title, {
      timeOut: 10000,
      closeButton: true
    });
  }

}
